import _ from 'lodash';
import validation from './validation.json';
import location from './location.json';
import dates from './dates.json';

/**
 * merge questions
 * @return {object} json
 */
export default function() {
  return _.merge(
    {
      ugc_did_you_know: {
        type: 'validation',
        question: 'Did you know <%= name %>?',
        options: {
          yes: {
            label: 'Yes',
            action: 'ugc_where_validate',
          },
          no: {
            label: 'No',
          },
          skip: {
            label: 'Not Sure',
            action: 'ugc_where_validate',
          },
        },
      },
    },
    validation,
    dates,
    location
  );
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/Questionnaire/data/questions.js